import jsonFile from "../json/CreateLotteryABI.json";
const CreateLotteryABI = jsonFile;

export default CreateLotteryABI;  